// extracted by mini-css-extract-plugin
module.exports = {"root":"StarfieldBackground_root__Cr5gY","light":"StarfieldBackground_light__Oc9Ms","stars":"StarfieldBackground_stars__Yue4t"};